import { Component, OnInit } from '@angular/core';
import { TeamsService } from '../services/teams.service';
import { PeoplesService } from '../services/peoples.service';
import { Team, TeamAdapter } from '../models/team';
import { People, PeopleAdapter } from '../models/people';
import { HomepageWidgetComponent } from './homepage-widget/homepage-widget.component';
import { OpenPositionsWidgetComponent } from './homepage-widget/open-positions-widget/open-positions-widget.component';
import { TeamStatusWidgetComponent } from './homepage-widget/team-status-widget/team-status-widget.component';
import { SlicePipe } from '@angular/common';
import { Widget } from '../models/widget';
import { Role, RoleAdapter } from '../models/role';
import { RolesService } from '../services/roles.service';
import { SkillsService } from '../services/skills.service';
import { Skill, SkillAdapter } from '../models/skill';
import { StatisticsService } from '../services/statistics.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SkillDistributionWidgetComponent } from './homepage-widget/skill-distribution-widget/skill-distribution-widget.component';
import { RoleDistributionWidgetComponent } from './homepage-widget/role-distribution-widget/role-distribution-widget.component';
import { HeadcountWidgetComponent } from "./hompage-widget/headcount-widget/headcount-widget.component";
import { map } from 'rxjs';
import { PagedResponse } from '../models/paged-response.model';
import { adaptPagedResponse } from '../operators/paged-response-operatros';


@Component({
  selector: 'app-homepage',
  standalone: true,
  imports: [
    HomepageWidgetComponent,
    OpenPositionsWidgetComponent,
    TeamStatusWidgetComponent,
    SkillDistributionWidgetComponent,
    RoleDistributionWidgetComponent,
    TranslatePipe,
    SlicePipe,
    HeadcountWidgetComponent
],
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss',
})
export class HomepageComponent implements OnInit {
  teams: Team[] = [];
  peoples: People[] = [];
  roles: Role[] = [];
  skills: Skill[] = [];
  widgets: Widget[] = [];

  constructor(
    private peoplesService: PeoplesService,
    private peopleAdapter: PeopleAdapter,
    private teamService: TeamsService,
    private teamAdapter: TeamAdapter,
    private rolesServices: RolesService,
    private roleAdapter: RoleAdapter,
    private skillsServices: SkillsService,
    private skillAdapter: SkillAdapter,
    private statisticsService: StatisticsService,
    private translate :TranslateService
  ) {}

  ngOnInit(): void {

    this.widgets = [
      new Widget(0, '', this.translate.instant('DASHBOARD.PEOPLES'), null), 
      new Widget(1, '', this.translate.instant('DASHBOARD.TEAMS'), null), 
      new Widget(2, '', this.translate.instant('DASHBOARD.SKILLS'), null), 
      new Widget(3, '', this.translate.instant('DASHBOARD.ROLES'), null), 
      
      new Widget(4, this.translate.instant('DASHBOARD.TEAMS_TYPE'), '', null, null, true), 
      new Widget(5, this.translate.instant('DASHBOARD.CONTRACTOR_RATIO'), '', null, null, true),
    ];

    this.teamService.getTeams().subscribe((teams: Team[]) => {
      this.teams = teams.map((team) => this.teamAdapter.adapt(team));
      this.updateWidgetData(1, this.teams.length);
      this.updateTeamTypeChartWidget(4);
    });

  
    this.peoplesService.get_peoples(null).subscribe((peoples: People[]) => {
      this.peoples = peoples.map((people) => this.peopleAdapter.adapt(people));
      this.updateWidgetData(0, this.peoples.length);
      this.updateContractorChartWidget(5);
    });

    this.rolesServices.getRoles().subscribe((roles: Role[]) => {
      this.roles = roles.map((role) => this.roleAdapter.adapt(role));
      this.updateWidgetData(3, this.roles.length);
    });

    this.skillsServices.getSkills(1, 1000)
    .pipe(
      // 1. Adaptation du contenu paginé
      adaptPagedResponse<Skill, Skill>(this.skillAdapter), 
      
      // 2. Extraction du tableau d'items adapté
      map((response: PagedResponse<Skill>) => response.items)
    )
    .subscribe((skills: Skill[]) => {
      this.skills = skills.map((skill) => this.skillAdapter.adapt(skill));
      this.updateWidgetData(2, this.skills.length);
    });
  }

  private updateWidgetData(widgetId: number, data: any): void {
    const targetWidget = this.widgets.find((widget) => widget.id === widgetId);
    if (targetWidget) {
      targetWidget.data = data;
    }
    targetWidget!.isLoading = false;
  }

  private updateTeamTypeChartWidget(widgetId: number) {
    const contractor_data = this.statisticsService.getTeamTypeChartData(this.teams);

    const labels = [];
    const values = [];
    for (const teamType in contractor_data) {
      labels.push(teamType);
      values.push(contractor_data[teamType]);
    }

    const data = {
      labels: labels,
      datasets: [
        {
          data: values,
        },
      ],
    };

    const targetWidget = this.widgets.find((widget) => widget.id === widgetId);
    if (targetWidget) {
      targetWidget.data = data;
      targetWidget.isChart = true; 
    }
    targetWidget!.isLoading = false;
  }

  private updateContractorChartWidget(widgetId: number) {
    const contractor_data = this.statisticsService.getContractorChartData(this.peoples);

    const data = {
      labels: ['Employee', 'Contractor'],
      datasets: [
        {
          data: contractor_data,
        },
      ],
    };

    const targetWidget = this.widgets.find((widget) => widget.id === widgetId);
    if (targetWidget) {
      targetWidget.data = data;
      targetWidget.isChart = true; 
    }
    targetWidget!.isLoading = false;
  }
}